import Constants from '../../analytics/constants';
import Log from '../../common/log';
import { SessionsTag } from '../../common/Constants';
export var SessionState;
(function (SessionState) {
    SessionState["STOPPED"] = "stopped";
    SessionState["STARTED"] = "started";
})(SessionState || (SessionState = {}));
/**
 * Enforces sendability rules based on session state
 */
export default class SendabilityPolicy {
    constructor(initialState = SessionState.STOPPED) {
        this.state = initialState;
    }
    /**
     * Check if a request can be sent
     * @param request - Request to check
     * @returns Sendability result with reason if not sendable
     */
    canSend(request) {
        const service = request.getService();
        const force = request.getForce();
        switch (service) {
            case Constants.Service.SESSION_START:
                return this.checkStartRequest(request, force);
            case Constants.Service.SESSION_STOP:
            default:
                return this.checkNonStartRequest(request, force);
        }
    }
    /**
     * Check if START request can be sent
     */
    checkStartRequest(request, force) {
        if (this.state === SessionState.STOPPED) {
            return { sendable: true };
        }
        if (force) {
            Log.debug(SessionsTag, 'START request sending even though session is already started (forced)');
            return { sendable: true };
        }
        Log.debug(SessionsTag, 'START request session is already started. Discarding request.');
        return { sendable: false, reason: 'session already started' };
    }
    /**
     * Check if non-START request can be sent
     */
    checkNonStartRequest(request, force) {
        if (this.state === SessionState.STARTED) {
            return { sendable: true };
        }
        if (force) {
            Log.debug(SessionsTag, 'Non-START request sending even though session is not started (forced)');
            return { sendable: true };
        }
        Log.debug(SessionsTag, 'Non-START request cannot be sent since session is not started yet. Discarding request.');
        return { sendable: false, reason: 'session not started' };
    }
    /**
     * Get current session state
     */
    getState() {
        return this.state;
    }
    /**
     * Set session state
     */
    setState(state) {
        this.state = state;
    }
    /**
     * Check if session is started
     */
    isStarted() {
        return this.state === SessionState.STARTED;
    }
    /**
     * Check if session is stopped
     */
    isStopped() {
        return this.state === SessionState.STOPPED;
    }
}
